import { useState } from 'react';

const THEME_STORAGE_KEY = 'choripan-theme';

const applyTheme = (isDarkMode: boolean) => {
  document.documentElement.classList.toggle('dark', isDarkMode);
};

const getSavedTheme = () => {
  try {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    if (savedTheme === 'light') return false;
    if (savedTheme === 'dark') return true;
  } catch {
    // Fall back to the device preference when browser storage is unavailable.
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

export const useTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const initialTheme = getSavedTheme();
    applyTheme(initialTheme);
    return initialTheme;
  });

  const toggleTheme = () => {
    setIsDarkMode(currentTheme => {
      const nextTheme = !currentTheme;
      applyTheme(nextTheme);
      try {
        localStorage.setItem(THEME_STORAGE_KEY, nextTheme ? 'dark' : 'light');
      } catch {
        // Keep the current page usable if browser storage is unavailable.
      }
      return nextTheme;
    });
  };

  return { isDarkMode, toggleTheme };
};
